'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PrintButton = require('./components/PrintButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PrintButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/print/lib/components/print-button/index.js
// module id = 1445
// module chunks = 1